export default {
  'userandregister-result.login.userName': '用户名',
  'userandregister-result.login.password': '密码',
  'userandregister-result.login.message-invalid-credentials': '账户或密码错误（admin/ant.design）',
  'userandregister-result.login.message-invalid-verification-code': '验证码错误',
  'userandregister-result.login.tab-login-credentials': '账户密码登录',
  'userandregister-result.login.tab-login-mobile': '手机号登录',
  'userandregister-result.login.remember-me': '自动登录',
  'userandregister-result.login.forgot-password': '忘记密码',
  'userandregister-result.login.sign-in-with': '其他登录方式',
  'userandregister-result.login.signup': '注册账户',
  'userandregister-result.login.login': '登录',
  'userandregister-result.register.register': '注册',
  'userandregister-result.register.get-verification-code': '获取验证码',
  'userandregister-result.register.sign-in': '使用已有账户登录',
  'userandregister-result.register-result.msg': '你的账户：{email} 注册成功',
  'userandregister-result.register-result.activation-email':
    '激活邮件已发送到你的邮箱中，邮件有效期为24小时。请及时登录邮箱，点击邮件中的链接激活帐户。',
  'userandregister-result.register-result.back-home': '返回首页',
  'userandregister-result.register-result.view-mailbox': '查看邮箱',
  'userandregister-result.navBar.lang': '语言',
};
